export const IMAGE_DOMAINS = [
  'imgur.com',
  'flickr.com',
  'postimages.org',
  'picsum.photos',
  'gstatic.com',
  'googleusercontent.com',
];
